import { Input } from '../../../../components/ui/input/SimpleInput';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import ButtonV2 from '../../../../components/ui/button/v2';
import { ChevronRight } from 'lucide-react';

interface CaseEvidenceModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (evidenceURL: string) => void;
}

const CaseEvidenceModal: React.FC<CaseEvidenceModalProps> = ({ isOpen, onClose, onSave }) => {
    const [evidenceURL, setEvidenceURL] = useState<string>('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setEvidenceURL(value);
    };

    const handleSave = () => {
        onSave(evidenceURL);
    };

    if (!isOpen) return null;

    const modalContent = (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto relative z-[10000]">
                <div className="space-y-4 p-6">
                    <div className="flex justify-between items-center pb-0">
                        <h2 className="text-xl font-semibold">Upload Evidence</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 focus:outline-none"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-foreground mb-1">URL</label>
                        <Input
                            type="text"
                            name="name"
                            placeholder='Enter Evidence URL'
                            value={evidenceURL}
                            className='px-3'
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="px-6 pb-6 flex gap-4 w-full">
                    <ButtonV2 disabled={!evidenceURL} className='w-full' variant="outline-primary" onClick={handleSave} suffix={<ChevronRight className='w-4 h-4'/>}>
                        Save & Proceed
                    </ButtonV2>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default CaseEvidenceModal;